// extracted by mini-css-extract-plugin
module.exports = {"container":"ReleaseNotesIndicator_container__2MpiH","releaseNotes":"ReleaseNotesIndicator_releaseNotes__3sCdG","notify":"ReleaseNotesIndicator_notify__2eb4i"};